export default "__VITE_PUBLIC_ASSET__71bba970__"